export default __webpack_public_path__ + "static/logo-f5ee5b56d7654781b476893739df7bbc.svg";